import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2SubmitResponse,
} from './types';

export async function submitIndirectTaxFilingV2({
  filingId,
  corporationId,
  token,
}: {
  filingId: string;
  corporationId: number;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2SubmitResponse>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}/submit?corporationId=${corporationId}`,
      { method: 'POST' },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to submit filing',
      };
    }
    const data: IIndirectTaxFilingV2SubmitResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to submit filing',
    };
  }
}
